export default __webpack_public_path__ + "static/media/button_close_icon.00bba507.svg";